import React from "react";
import Container from "Components/Container/Container";

const HR = ({ data }) => {
  return (
    <section className="scroll-section mb-24 lg:py-24 ">
      <Container className="h-full">
        <div className="flex flex-col h-full lg:flex-row justify-center items-center gap-y-4 gap-x-8">
          <div className="flex-1 lg:h-[90vh]">
            <img
              className="lg:min-h-[90vh] my-auto object-cover"
              src={data?.image}
              alt=""
            />
          </div>
          <div className="text-white flex-1">
            <h2 className="bebas text-4xl lg:text-5xl mb-2">{data?.title}</h2>
            <div
              className="text-lg custom-content"
              dangerouslySetInnerHTML={{ __html: data?.text }}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HR;
